import { render, staticRenderFns } from "./BStep1.vue?vue&type=template&id=648f0c28&scoped=true"
import script from "./BStep1.vue?vue&type=script&lang=js"
export * from "./BStep1.vue?vue&type=script&lang=js"
import style0 from "./BStep1.vue?vue&type=style&index=0&id=648f0c28&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "648f0c28",
  null
  
)

export default component.exports